<template>
  <div class="answer-image-input">
    <input
      type="checkbox"
      name="answer"
      :id="answer.answerId"
      :value="answer.answerId"
      @click="$emit('answerSelected', $event.target.value)"
    />
    <label
      class="answer-label"
      :for="answer.answerId"
      :style="{
        backgroundColor: isSelected ? getAnswerBackgroundColor(poll, index) : '#fff',
        color: isSelected ? getAnswerColor(poll, index) : '#000'
      }"
    >
      <img v-if="!!answer.image" :src="disableCache(answer.image) || getImagePlaceholder()" class="answer-image" />
      <div class="answer-content break-word">{{ index + 1 }} - {{ answer.texts[lang] }}</div>
    </label>
  </div>
</template>

<script>
import { getAnswerBackgroundColor, getAnswerColor } from '@/services/ColorService';
import { getImagePlaceholder } from '@/services/StyleService';
import { disableCache } from '@/components/utils';
import { mapGetters } from 'vuex';

export default {
  name: 'answer-image-input',
  computed: {
    ...mapGetters({ lang: 'getInputLanguage' })
  },
  props: {
    poll: Object,
    answer: Object,
    index: Number,
    isSelected: Boolean
  },
  methods: {
    getAnswerBackgroundColor,
    getAnswerColor,
    getImagePlaceholder,
    disableCache
  }
};
</script>

<style lang="scss" scoped>
.answer-image-input {
  margin: 5px;
  background-color: #fff;
  height: 100%;
}

input[type='checkbox'] {
  display: none;
}

.answer-label {
  cursor: pointer;
  display: block;
  height: 100%;
  box-shadow: var(--box-shadow);
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 3px;
}

.answer-image {
  background-color: #edeff0;
  width: 100%;
}

.answer-content {
  margin-top: 5px;
  padding: 10px;
  font-weight: 700;
}
</style>
